'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = exports.defaults = undefined;

var _defaults = require('./defaults.js');

var defaults = _interopRequireWildcard(_defaults);

var _config = require('./config.js');

var config = _interopRequireWildcard(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.defaults = defaults;
exports.config = config;


//////////////////
// WEBPACK FOOTER
// ./~/uport-transports/lib/network/index.js
// module id = 907
// module chunks = 0